import type {
	CustomItem,
	DropLogosType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropLogos = (item: Item | CustomItem): item is DropLogosType => {
	return !!(item && item.__typename === 'Drop_Logos');
};
